import React, { useState, useEffect, useCallback } from "react";
import { Button } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { GlobalModal } from "../../helper/GlobalModal";
import TranchesForm from "../../components/TranchesForm";
import TranchesTable from "../../components/TranchesTable";
import { showNotification } from "../../service/showNotification";
import {
  deleteTranche,
  downloadTrancheData,
  fetchTranches,
} from "../../service/api";
import useDebounce from "../../hooks/useDebounce";
import { formatToYYYYMMDD } from "../../utils/formatDate";
import styles from "./index.module.css";
import clsx from "clsx";
import { FaEdit, FaHistory } from "react-icons/fa";
import TooltipWrapper from "../../helper/Tooltip";
import TrancheHistoryModal from "../../components/TranchesTable/TranchHistory/TrancheHistoryModal";
import AttachAssetsToTranches from "../../components/TranchesForm/AttachAssetsToTranches";
import { MdDelete } from "react-icons/md";
import ConfirmationModal from "../../helper/ConfirmationModal";
import { TrancheModule } from "../../utils/constant";
import Select from "react-select";
import { IoDocumentSharp } from "react-icons/io5";
import TrancheDocumentModal from "../../components/TranchesTable/TrancheDocumentModel";
import { FiRefreshCw } from "react-icons/fi";
import { pullBosDocument } from "../../service/api";
import { ButtonLoader } from "../../components/ButtonLoader";
import { tracker } from "../../service/mixpanel";
import { useExport } from "../../context/ExportContext";
import { exportJobName } from "../../helper/ExportFile/data";
import TrancheDocumentApi from "./TrancheDocumentApi";
import { CiFilter } from "react-icons/ci";
import { RxCross2 } from "react-icons/rx";
import { RiArrowRightDoubleFill } from "react-icons/ri";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import auditStyles from "../../components/AssetV2Audit/index.module.css";

const trancheOptions = [
  { value: "all", label: "All" },
  { value: "Tranche", label: "Manual" },
  { value: "Tranche Bot", label: "Bot" },
];
const customStyles = {
  menuList: (base) => ({
    ...base,
    maxHeight: window.innerWidth <= 768 ? 120 : 160, // Show ~4 items on small screens
    overflowY: "auto",
  }),
};
const docIconStyle = {
  color: "#1976d2", // blue (good for DOC/DOCX)
  fontSize: "1.125rem", // same size as PDF icon
  cursor: "pointer",
  pointerEvents: "auto",
  opacity: 1,
};
const columns = [
  { _id: "trancheId", label: "Tranche ID", isSorting: true },
  { _id: "trancheName", label: "Tranche Name", isSorting: true },
  { _id: "clientName", label: "Client Name", isSorting: true },
  { _id: "groupType", label: "Group Type", isSorting: true },
  { _id: "entityName", label: "Entity Name", isSorting: true },
  { _id: "assetCount", label: "Asset Count", isSorting: true },
  // tranche bot
  { _id: "opportunityId", label: "Opportunity Id", isSorting: false },
  { _id: "opportunityName", label: "Opportunity Name", isSorting: false },
  { _id: "ecToDeploy", label: "EC to Deploy", isSorting: false },
  { _id: "itcPercent", label: "ITC Percent", isSorting: false },
  {
    _id: "internalMarkupPercent",
    label: "Internal Markup Percent",
    isSorting: false,
  },
  {
    _id: "affiliateMarkupPercent",
    label: "Affiliate Markup Percent",
    isSorting: false,
  },
  { _id: "contactGroup", label: "Contact Group", isSorting: false },
  { _id: "ampThirtyPercent", label: "AMP Thirty Percent", isSorting: false },
  { _id: "ampFortyPercent", label: "AMP Forty Percent", isSorting: false },
  { _id: "stateString", label: "State", isSorting: false },
  { _id: "totalItcPercent", label: "Total ITC Percent", isSorting: false },
  { _id: "trancheContactId", label: "Contact ID", isSorting: false },
  {
    _id: "totalPurchaseAmount",
    label: "Total Purchase Amount",
    isSorting: false,
  },
  { _id: "status", label: "Status", isSorting: false },
  { _id: "rejectionMessage", label: "Rejection Message", isSorting: false },
  { _id: "entityFullAddress", label: "Entity Full Address", isSorting: false },

  { _id: "attachAsset", label: "Attach Asset", isSorting: false },
  { _id: "action", label: "Action", isSorting: false },
];

const TrancheFilterPopup = ({ selectedType, setSelectedType, recordType, setRecordType, onClose }) => {
  const [wideMode, setWideMode] = useState(false);

  const recordTypeOptions = [
    { label: "Live Data (Non-Test)", value: "live_data" },
    { label: "Test Data Only", value: "test_data" },
  ];

  return (
    <div style={{ position: "relative" }} onClick={onClose}>
      <div
        className={clsx(
          auditStyles.dropdownContainer,
          wideMode && auditStyles.dropdownContainerWide
        )}
        onClick={(e) => e.stopPropagation()}
        style={{ right: 0, zIndex: 9999 }}
      >
        <div className={auditStyles.header}>
          <button
            type="button"
            onClick={() => setWideMode(!wideMode)}
            title={wideMode ? "Switch to narrow view" : "Switch to wide view"}
            className={auditStyles.layoutToggleBtn}
          >
            {wideMode ? (
              <RiArrowRightDoubleFill size={18} />
            ) : (
              <MdOutlineKeyboardDoubleArrowLeft size={18} />
            )}
          </button>

          <span>ADD CRITERIA</span>
          
          <button className={auditStyles.closeFilterBtn} onClick={onClose}>
            <RxCross2 size={20} />
          </button>
        </div>

        <div className={auditStyles.fieldsWrapper}>
          
          {/* Tranche Type Filter */}
          <div className={auditStyles.field}>
            <label>Tranche Type</label>
            <Select
              value={selectedType}
              onChange={(sel) => setSelectedType(sel)} 
              options={trancheOptions}
              maxMenuHeight={160}
              menuPlacement="bottom"
              placeholder="Select Type"
            />
          </div>

          {/* Record Type Filter */}
          <div className={auditStyles.field}>
            <label>Record Type</label>
            <Select
              value={
                recordType
                  ? recordTypeOptions.find((o) => o.value === recordType)
                  : null
              }
              onChange={(sel) => setRecordType(sel?.value || "")}
              options={recordTypeOptions}
              maxMenuHeight={160}
              menuPlacement="bottom"
              placeholder="-- All --"
              isClearable
            />
          </div>

        </div>

        <button
          className={`${auditStyles.applyButton} ${auditStyles.fullWidthBtn}`}
          onClick={onClose}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

const TranchesPage = () => {
  const [tranches, setTranches] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalTranches, setTotalTranches] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isTrancheDocumentModalOpen, setIsTrancheDocumentModalOpen] =
    useState(false);
  const [sort, setSort] = useState(
    columns
      .filter((item) => item.isSorting)
      .reduce((acc, item) => {
        acc[item._id] = 0;
        return acc;
      }, {})
  );
  const [selectedType, setSelectedType] = useState(trancheOptions[0]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterRecordType, setFilterRecordType] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const handleTypeChange = (selectedOption) => {
    tracker.tranches.statusFilterChange(selectedOption.value);
    setSelectedType(selectedOption);
  };
  // modal
  const [isModal, setIsModal] = useState(false);
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const [modalName, setModalName] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [isAmpVantage, setIsAmpVantage] = useState(false);
  const [download, setDownload] = useState(false);
  const [isApiModalOpen, setIsApiModalOpen] = useState(false);
  const { addJob } = useExport();
  const [assetsRefreshSignal, setAssetsRefreshSignal] = useState(null);

  const toggleModal = (name = "", row = null) => {
    if (name === "create_tranche") {
      tracker.tranches.addTrancheClick();
    }
    if (name === "edit_tranche") {
      tracker.tranches.editTrancheClick(row?._id);
    }
    if (name === "history") {
      tracker.tranches.trancheDocuments.trancheHistory(row?._id);
    }
    setIsModal((prev) => !prev);
    setModalName(name);
    setSelectedRow(row);
  };

  const toggleConfirmationModal = (name = "", row = null) => {
    if (name === "delete_tranche") {
      tracker.tranches.deleteTrancheClick(row?._id);
    }
    setIsConfirmationModal((prev) => !prev);
    setModalName(name);
    setSelectedRow(row);
  };

  const handleAssetsAttached = (trancheId) => {
    if (!trancheId) return;
    setAssetsRefreshSignal({ trancheId, at: Date.now() });
  };

  const fetchTranchesData = useCallback(async () => {
    try {
      setLoading(true);
      if (debouncedSearchTerm && debouncedSearchTerm.length > 0) {
        tracker.tranches.tranchesSearch(debouncedSearchTerm);
      }
      const params = {
        page: currentPage,
        limit: itemsPerPage,
        searchTerm: debouncedSearchTerm,
        sort: JSON.stringify(sort),
        moduleName: selectedType.value ?? "all",
        recordType: filterRecordType,
      };
      const res = await fetchTranches(params);
      setTranches(res.data.data);
      setTotalPages(Math.ceil(res.data.totalDocs / itemsPerPage) || 1);
      setTotalTranches(res.data.totalDocs);
    } catch (error) {
      console.error("Error fetching tranches:", error);
      showNotification("error", "Failed to fetch tranches. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage, debouncedSearchTerm, sort, selectedType, filterRecordType]);

  const handleDeleteTranche = async () => {
    tracker.tranches.deleteTrancheConfirmed(selectedRow?._id);
    const selectedId = selectedRow?._id;
    toggleConfirmationModal();
    try {
      await deleteTranche(selectedId);
      showNotification("success", "Tranche deleted successfully!");
      fetchTranchesData();
    } catch (error) {
      console.error("Error deleting tranche:", error);
      showNotification("error", "Failed to delete tranche.");
    }
  };
  //Pull BOS Document
  const [pushPullLoading, setPushPullLoading] = useState({});
  const handlePullBos = async (colId) => {
    tracker.tranches.tranchePullFromBOSClick(selectedRow?._id);
    setPushPullLoading((prev) => ({ ...prev, [colId]: true }));

    try {
      await pullBosDocument(selectedRow?.trancheId);
      showNotification("success", "Tranche document(s) pulled successfully.");
    } catch (err) {
      const msg =
        err?.response?.data?.message || "Failed to pull Tranche document(s).";
      showNotification("error", msg);
    } finally {
      setPushPullLoading((prev) => ({ ...prev, [colId]: false }));
    }
  };

  useEffect(() => {
    tracker.tranches.pageView();
  }, []);

  useEffect(() => {
    fetchTranchesData();
  }, [fetchTranchesData]);

  const handleTrancheDataExport = async () => {
    tracker.tranches.exportTranchesClick();
    try {
      setDownload(true);
      const response = await downloadTrancheData(debouncedSearchTerm, false, filterRecordType);
      addJob({
        name: exportJobName.trancheDocumentExport,
        id: response.data.jobId,
      });

      showNotification("success", "Tranche export started successfully");
    } catch (error) {
      console.error("Error exporting tranche data:", error);
      showNotification("error", "Failed to export tranche data.");
    } finally {
      setDownload(false);
    }
  };

  const modalMap = {
    history: {
      component: <TrancheHistoryModal trancheId={selectedRow?._id} />,
      title: "Tranche History",
    },
    create_tranche: {
      component: (
        <TranchesForm
          getTranches={fetchTranchesData}
          onClose={toggleModal}
          fetchTranches={fetchTranchesData}
        />
      ),
      title: "New Tranches",
    },
    edit_tranche: {
      component: (
        <TranchesForm
          tranche={selectedRow}
          getTranches={fetchTranchesData}
          onClose={toggleModal}
        />
      ),
      title: "Edit Tranche",
    },
    attach_asset: {
      component: (
        <AttachAssetsToTranches
          tranche={selectedRow}
          loadTranches={fetchTranchesData}
          onClose={toggleModal}
          onAssetsAttached={handleAssetsAttached}
        />
      ),
      title: "Attach Asset to Tranche",
      size: "lg",
    },
  };

  const confirmationModalMap = {
    delete_tranche: {
      title: "Delete Tranche",
      message: "Are you sure you want to delete this tranche?",
      confirmText: "Delete",
      cancelText: "Cancel",
      onConfirm: handleDeleteTranche,
    },
    pull_bos_document: {
      title: "Pull Tranche Documents",
      message:
        "This will replace the current tranche document(s) with the document(s) present on Zoho. Continue?",
      confirmText: "Pull",
      cancelText: "Cancel",
      onConfirm: async () => {
        console.log(selectedRow);
        if (selectedRow?.trancheId) {
          await handlePullBos(selectedRow.trancheId);
        }
        toggleConfirmationModal();
      },
    },
  };

  const rows = tranches?.map((tranche) => {
    return {
      _id: tranche._id,
      trancheId: tranche.trancheId,
      trancheName: tranche.trancheName,
      clientName: tranche?.clientName,
      groupType: tranche?.groupType,
      entityName: tranche?.entityName,
      assetCount: tranche?.assetCount || 0,

      // tranche bot
      opportunityId: tranche?.opportunityId,
      opportunityName: tranche?.opportunityName,
      ecToDeploy: tranche?.ecToDeploy,
      itcPercent: tranche?.itcPercent,
      internalMarkupPercent: tranche?.internalMarkupPercent,
      affiliateMarkupPercent: tranche?.affiliateMarkupPercent,
      contactGroup: tranche?.contactGroup,
      ampThirtyPercent: tranche?.ampThirtyPercent,
      ampFortyPercent: tranche?.ampFortyPercent,
      stateString: tranche?.stateString,
      totalItcPercent: tranche?.totalItcPercent,
      totalPurchaseAmount: tranche?.totalPurchaseAmount,
      status: tranche?.status,
      rejectionMessage: tranche?.rejectionMessage,
      trancheContactId: tranche?.trancheContactId,
      entityFullAddress: tranche?.entityFullAddress,

      attachAsset: (
        <div onClick={(e) => e.stopPropagation()}>
          <Button
            variant="primary"
            size="sm"
            disabled={TrancheModule.TRANCHE_BOT === tranche?.moduleName}
            onClick={() => toggleModal("attach_asset", tranche)}
          >
            Attach Assets
          </Button>
        </div>
      ),
      assets: tranche?.assetIds || [],
      createdAt: formatToYYYYMMDD(new Date(tranche.createdAt || Date.now())),
      updatedAt: formatToYYYYMMDD(new Date(tranche.updatedAt || Date.now())),
      action: (
        <div onClick={(e) => e.stopPropagation()}>
          <TooltipWrapper tooltip="View history">
            <FaHistory
              className={clsx(styles.icon, styles.normalIcon)}
              onClick={() => toggleModal("history", tranche)}
            />
          </TooltipWrapper>
          <TooltipWrapper tooltip="Edit">
            <FaEdit
              className={clsx(styles.editIcon, styles.icon)}
              onClick={() => toggleModal("edit_tranche", tranche)}
            />
          </TooltipWrapper>
          <TooltipWrapper tooltip="Tranche Files">
            <IoDocumentSharp
              style={docIconStyle}
              onClick={() => {
                setSelectedRow(tranche);
                setIsAmpVantage(
                  tranche?.groupType == "AmpVantage Energy" ?? false
                );
                setIsTrancheDocumentModalOpen(true);
                tracker.tranches.trancheDocumentFileClick(tranche.trancheId);
              }}
            />
          </TooltipWrapper>
          {/* PULL BOS */}
          <TooltipWrapper tooltip="Pull Tranche Document(s)">
            <FiRefreshCw
              className={styles.docIconStyle}
              title="Pull latest tranche document(s)"
              style={{
                cursor: pushPullLoading[tranche.trancheId]
                  ? "not-allowed"
                  : "pointer",
                opacity: pushPullLoading[tranche.trancheId] ? 0.5 : 1,
              }}
              onClick={() => {
                if (pushPullLoading[tranche.trancheId]) return;
                toggleConfirmationModal("pull_bos_document", tranche);
              }}
            />
          </TooltipWrapper>
          <TooltipWrapper tooltip="Delete">
            <MdDelete
              className={clsx(styles.deleteIcon, styles.icon)}
              onClick={() => toggleConfirmationModal("delete_tranche", tranche)}
            />
          </TooltipWrapper>
        </div>
      ),
    };
  });

  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4 mx-3">
        <div className="d-block mb-4 mb-xl-0">
          <h4>Tranches</h4>
        </div>

        <div className="asset-toolbar d-flex align-items-center gap-3">
          
          <div style={{ position: "relative" }}>
            <Button
              variant="outline-secondary"
              className="d-flex align-items-center gap-2 bg-white text-dark border"
              onClick={() => setIsFilterOpen(!isFilterOpen)}
            >
              <CiFilter size={18} /> Filters {filterRecordType ? "(2)" : "(1)"}
            </Button>

            {isFilterOpen && (
              <TrancheFilterPopup
                selectedType={selectedType}
                setSelectedType={handleTypeChange}
                recordType={filterRecordType}
                setRecordType={setFilterRecordType}
                onClose={() => setIsFilterOpen(false)}
              />
            )}
          </div>

          <input
            type="text"
            placeholder="Tranches ID & Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button onClick={() => toggleModal("create_tranche")}>
            New Tranche
          </Button>
          <Button onClick={handleTrancheDataExport} variant="primary">
            {download ? "Exporting..." : "Export Tranche Data"}
          </Button>
          <Button variant="primary" onClick={() => setIsApiModalOpen(true)}>
            API Management
          </Button>
        </div>
      </div>

      <div className="asset-summary-container mx-0 mb-4">
        <div className="asset-summary-box">
          {loading ? (
            <Skeleton count={1} width={120} />
          ) : (
            `Total Tranches: ${totalTranches}`
          )}
        </div>
      </div>

      <TranchesTable
        columns={columns}
        rows={rows}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        sort={sort}
        setSort={setSort}
        assetsRefreshSignal={assetsRefreshSignal}
      />

      <GlobalModal
        isOpen={isModal}
        onClose={() => toggleModal()}
        children={modalMap[modalName]?.component}
        title={modalMap[modalName]?.title || "Something went wrong"}
        size={modalMap[modalName]?.size || "xl"}
      />

      <ConfirmationModal
        show={isConfirmationModal}
        onHide={() => toggleConfirmationModal()}
        onConfirm={confirmationModalMap[modalName]?.onConfirm}
        title={confirmationModalMap[modalName]?.title}
        message={confirmationModalMap[modalName]?.message}
        confirmText={
          modalName === "pull_bos_document" && selectedRow?.trancheId ? (
            pushPullLoading[selectedRow.trancheId] ? (
              <ButtonLoader show />
            ) : (
              "Pull"
            )
          ) : (
            confirmationModalMap[modalName]?.confirmText || "Confirm"
          )
        }
        cancelText={confirmationModalMap[modalName]?.cancelText || "Cancel"}
      />
      <GlobalModal
        isOpen={isTrancheDocumentModalOpen}
        title="Tranche Document Files"
        onClose={() => {
          setIsTrancheDocumentModalOpen(false);
          setIsAmpVantage(false);
        }}
        children={
          <TrancheDocumentModal
            trancheId={selectedRow?._id}
            isAmpVantage={isAmpVantage}
          />
        }
      />
      <GlobalModal
        isOpen={isApiModalOpen}
        title="Tranche API Management"
        onClose={() => setIsApiModalOpen(false)}
        size="xl"
      >
        <TrancheDocumentApi />
      </GlobalModal>
    </>
  );
};

export default TranchesPage;
